
import { useRootStore } from '~/store/root'
import { whiteListNoIframeRoutes } from '~/libs/iframe-only-check'

export default defineNuxtRouteMiddleware((to) => {
  const { authUser, isEmbedded } = useRootStore()
  const isEmbeddedUser = authUser?.isEmbedded && isEmbedded
  const isEmbeddedPath = to.path.includes('/embedded')
  const isRequirementsPath = to.path.startsWith('/requirements')

  if (whiteListNoIframeRoutes.includes(to.path)) {
    // Whitelisted routes don't apply to the /embedded path rule
    return
  }

  if (!isEmbeddedUser && isEmbeddedPath) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page not found.',
      data: {
        isEmbedded,
      },
      fatal: true
    })
  }

  if (isEmbeddedUser && !isEmbeddedPath && !isRequirementsPath) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Page not found.',
      data: {
        isEmbedded,
      },
      fatal: true
    })
  }
})
